import React from "react";

export default class Rate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputWeight: 0.5,
            ratedWeight: 0,
            ratedPrice: 0,
        }
        this.inputRef = React.createRef();
    }

    render() {
        return (
            <div>
                <h2 className="mt-4">Rate</h2>
                <label htmlFor="weight" className="form-label">Weight, kg</label>
                <input type="number" className="form-control" id="weight" step="0.1" min="0.1"
                       value={this.state.inputWeight}
                       ref={this.inputRef}
                       onChange={(e) => {
                           this.setState({
                               inputWeight: e.target.value,
                           })
                       }}
                />
                <button type="submit" className="btn btn-success mt-4"
                        onClick={this.rate}
                >
                    Rate
                </button>
                <div className="mt-4">
                    {this.state.ratedPrice !== 0 ?
                        <span><b>{this.state.ratedPrice + 5}$</b> ({this.state.ratedPrice}$ + 5$ for weight {this.state.ratedWeight}kg)</span> :
                        null
                    }
                </div>
            </div>
        );
    }

    rate = (e) => {
        this.setState((prevState) => ({
            ratedWeight: prevState.inputWeight,
            ratedPrice: price(prevState.inputWeight),
        }), () => {
            this.inputRef.current.focus()
        })
    }

    componentDidMount() {
        this.inputRef.current.focus();
    }
}

function price(weight) {
    const w = Math.ceil(weight)
    return w * 5
}
